import React from "react";
import { useStyles } from "./styles";

export const StatisticWidgetTable = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  return (
    <div className={classes.content} ref={ref}>
      {children}
    </div>
  );
};
StatisticWidgetTable.muiName = "StatisticWidgetTable";
StatisticWidgetTable.displayName = "StatisticWidgetTable";

export default StatisticWidgetTable;

export * from "./StatisticWidgetRow";
export * from "./StatisticWidgetCell";
